import type Recipients from '../store/schema/Recipients';
import type RecipientWellWithFindControlViewState from 'owa-recipient-types/lib/types/RecipientWellWithFindControlViewState';
import type EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';

const TO_WELL_INDEX = 0;
const CC_WELL_INDEX = 1;
const BCC_WELL_INDEX = 2;

export default function getRecipientsFromRecipientWells(
    recipientWells: RecipientWellWithFindControlViewState[]
): Recipients {
    return {
        toRecipients: getRecipientsFromWell(recipientWells[TO_WELL_INDEX]),
        ccRecipients: getRecipientsFromWell(recipientWells[CC_WELL_INDEX]),
        bccRecipients: getRecipientsFromWell(recipientWells[BCC_WELL_INDEX]),
    };
}

function getRecipientsFromWell(well: RecipientWellWithFindControlViewState): EmailAddressWrapper[] {
    if (well?.recipients) {
        return well.recipients.map(recipient => recipient.persona.EmailAddress);
    }

    return [];
}
